var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationmodal2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECF0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 24.3008C14 18.8008 18.5 14.3008 24 14.3008C27.9 14.3008 31.3 16.5008 32.9 19.8008M34 24.3008C34 29.8008 29.5 34.3008 24 34.3008C20.1 34.3008 16.7 32.1008 15.1 28.8008",
    stroke: "#2C54E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 21.3008C25.657 21.3008 27 22.6438 27 24.3008C27 25.9578 25.657 27.3008 24 27.3008C22.343 27.3008 21 25.9578 21 24.3008C21 22.6438 22.343 21.3008 24 21.3008Z",
    stroke: "#2C54E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8002 14L33.0002 19.9L27.0002 19.1M14.2002 34.6L15.0002 28.7L21.0002 29.5",
    stroke: "#2C54E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationmodal2);
export default __webpack_public_path__ + "static/media/reservationmodal2.9c2572a154e4895a64ac649f7be40f95.svg";
export { ForwardRef as ReactComponent };